import React from 'react';
import * as msgpub from "msgpub";
import { TextInput, Box, Text, Grid, ResponsiveContext, Select, Anchor } from "grommet";
import { Button as ButtonGrom } from "grommet";
import { TextArea as TextAreaGrom } from "grommet";
import { FormLock, View } from "grommet-icons";
import { MainStyleForGrommet, HeaderStyle, HeaderSpanStyle, SelectStyle } from '../constant/Styles';
import { QoSstrs } from '../constant/Constant';

export function toStringArray(array: msgpub.AppTopicLabel[] | msgpub.TopicAppUser[]): string[]{
    let ret: string[] = [];
    array.forEach((e: msgpub.AppTopicLabel | msgpub.TopicAppUser) => {        
        ret.push(JSON.stringify(e));
    });
    return ret;
}

export function Button(props: { name: string, callback: any, disabled: boolean }) {
    const { name, callback, disabled } = props;
    return (
        // typeにbutton属性を与えないとリロードしてしまう
        <button type="button" disabled={disabled} onClick={callback}>{name}</button>
    );
}

export function ButtonG(props: { name: string, callback: any, disabled: boolean }) {
    const { name, callback, disabled } = props;

    return (
        // typeにbutton属性を与えないとリロードしてしまう
        <ButtonGrom disabled={disabled} onClick={callback} label={name}/>
    );
}

export function Connected(props: { msg: string }) {
    const { msg } = props;
    return (
        <Box 
            background="status-ok"
            width="small"
            direction="row"
            align="center"
            round="small"
            border
        >
            <Text textAlign="center">{msg}</Text>
        </Box>
    );
}

export function Log(props: { log: string, name: string }) {
    const { log, name } = props;
    React.useEffect(() => {
        let textarea: HTMLCollectionOf<HTMLTextAreaElement> = document.getElementsByTagName('textarea');
        textarea[0].scrollTop = textarea[0].scrollHeight;
    });

    return (
        <div style={{whiteSpace: 'pre-line'}}>
            <h3>{name}</h3>
            <textarea cols={40} rows={6} value={log}/>
        </div>
    );
} 

export function TextArea(props: { texts : string, name: string, disabled: boolean, id: string, onChange?: any }) {
    const { texts, name, disabled, id, onChange } = props;
    const size = React.useContext(ResponsiveContext);
    const cols = size === 'large' ? 20 : size === 'medium' ? 30 : 20;

    // レンダー後にログのスクロールを最下部に移動させる
    React.useEffect(() => {
        let textarea: HTMLElement | null = document.getElementById(id);
        if (textarea !==null)
            textarea.scrollTop = textarea.scrollHeight;
    });

    return (
        <div style={{whiteSpace: 'pre-line'}}>
            <Grid
                rows={['auto', 'auto']}
                columns={['auto']}
                gap="xsmall"
                areas={[
                    { name: 'main', start: [0, 1], end: [0, 1] },
                ]}
            >
                <Box {...MainStyleForGrommet}>
                    <TextAreaGrom id={id} disabled={disabled} cols={cols} rows={6} value={texts} placeholder={name} onChange={onChange}/>
                </Box>
            </Grid>
        </div>
    );
}

export function InputForm(props: { type: string, placeholder: string, value: string, onChange: any, disabled: boolean}) {
    const { type, placeholder, value, onChange, disabled } = props;

    return (
        <input type={type} disabled={disabled} placeholder={placeholder} value={value} onChange={onChange} />
    );
}

export function TokenForm(props: { type: string, placeholder: string, value: string, onChange: any, setTypeForPswd: any, disabled: boolean}) {
    const { type, placeholder, value, onChange, setTypeForPswd, disabled } = props;
    const [ checked, setChecked ] = React.useState(false);

    return (
        <div>
            <input type={type} disabled={disabled} placeholder={placeholder} value={value} onChange={onChange} /><br />
            <input type={"checkbox"} disabled={disabled} checked={checked} onChange={() => {
                setChecked(!checked);
                type === "text" ? setTypeForPswd("password") : setTypeForPswd("text");
            }} />
            {"show token"}
        </div>
    );
}

export function TokenInput(props: {placeholder: string, value: string, onChange: any, disabled: boolean}) {
    const {placeholder, value, onChange, disabled} = props;
    const [reveal, setReveal] = React.useState(false);
    return (
        <Box
            pad="none"
            width="small"
            direction="row"
            align="center"
            round="xsmall"
            background="white"
            border
        >
            <TextInput
                plain
                type={reveal ? "text" : "password"}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
            />
            <ButtonGrom
                icon={reveal ? <FormLock size="medium" /> : <View size="medium" />}
                onClick={() => setReveal(!reveal)}
                disabled={disabled}
            />
        </Box>
    );
  };

export function QOS(props: {onChange: any, disabled: boolean}){
    const {onChange, disabled} = props;
    return (
        <select disabled={disabled} onChange={onChange}>
            <option value={msgpub.QoS.AT_MOST_ONCE}>0: at not once</option>
            <option value={msgpub.QoS.AT_LEAST_ONCE}>1: at least once</option>
            <option value={msgpub.QoS.EXACTLY_ONCE}>2: exactly once</option>
        </select>
    );
}

export function QoS(props: {setQos: any, disabled: boolean}){
    const {setQos, disabled} = props;
    const [value, setValue] = React.useState(QoSstrs[0]);

    return (
        <Select 
            margin="xsmall"
            options={[
                QoSstrs[0],
                QoSstrs[1],
                QoSstrs[2],
            ]}
            value={value}
            disabled={disabled}
            onChange={({option}) => {
                setValue(option);
                if (option === QoSstrs[0]) {
                    setQos(0);
                } else if (option === QoSstrs[1]) {
                    setQos(1);
                } else {
                    setQos(2);
                }
            }}
            {...SelectStyle}
        />
    );
}
export function Checkbox(props: {name: string, keep: boolean, onChange: any, disabled: boolean}){
    const { name, keep, onChange, disabled } = props;
    const [ checked, setChecked ] = React.useState(false);

    return(
        <div>
            <input type={"checkbox"} checked={checked} disabled={disabled} onChange={() => {
                setChecked(!checked);
                onChange(!keep);
            }} />
            {name}
        </div>
    );
}

export function Heading(props: {title: string}){
    const {title} = props;

    return (
        <h4 {...HeaderStyle}>
            <span {...HeaderSpanStyle}>
                {title}
            </span>
        </h4>
    );
}

const FooterAnchorStyle = (URL: string, label: string) => {
    return {
        href: URL,
        label: label,
        target: "_blank"
    };
}

export function Footer(){
    return (
        <Box background="white" style={{borderTop: "solid 1px"}}>
            <Text textAlign="center" style={{fontSize: "12px"}}>
            Copyright © OGIS-RI Co.,Ltd. All rights reserved.<br/>
            This site uses <Anchor {...FooterAnchorStyle("https://github.com/grommet/grommet", "grommet")}/> that is distributed in <Anchor {...FooterAnchorStyle("http://www.apache.org/licenses/LICENSE-2.0", "the Apache License 2.0")}/>.
            </Text>
        </Box>
    );
}